<template>
	<v-autocomplete
		v-model="invoice"
		:items="items"
		:item-text="text"
		:item-value="value"
		dense
		outlined
		filled
		clearable
		label="Seleccione una factura"
		no-data-text="No hay facturas"
		:loading="loading"
		@change="setInvoice"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	props: {
		id: {
			type: String,
			default: '',
		},
		setInvoice: {
			type: Function,
			required: true,
		},
		selected: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			invoice: null,
			loading: false,
		};
	},
	computed: {
		...mapGetters({
			items: 'User/invoice',
		}),
	},
	watch: {
		id() {
			this.getInvoice();
		},
		selected(newVal) {
			if (newVal !== 2) {
				this.invoice = null;
			}
		},
	},
	mounted() {
		if (this.id) {
			this.getInvoice();
		}
	},
	methods: {
		getInvoice() {
			this.loading = true;
			this.fetchInvoiceByIdUser(this.id)
				.then(() => (this.loading = false))
				.catch(() => (this.loading = false));
		},
		text(text) {
			return `${text.month} $${text.mount}`;
		},
		value(text) {
			return text;
		},
		...mapActions({
			fetchInvoiceByIdUser: 'User/fetchInvoiceByIdUser',
		}),
	},
};
</script>
